__webpack_require__.p = "https://www.ikea.com/sa/ar/local-apps/alsulaiman-purchase-handler/";